import { Form } from "react-bootstrap";

import type { DistributionChannelRequest, Vendor } from "Src/api/Dto";

interface Props {
  handleChangeDistributionChannel: (e: React.ChangeEvent<HTMLInputElement>) => void;
  distributionChannels: DistributionChannelRequest[];
  vendor: Vendor;
}

export function DistributionChannels({ handleChangeDistributionChannel, distributionChannels, vendor }: Props) {
  return (
    <>
      {distributionChannels?.map((setting, index) => {
        const distributionChannelResponse = vendor.distributionChannels[index];

        return (
          <div key={index}>
            <Form className="mb-3">
              <div className="col-md-10">
                <Form.Check
                  checked={setting.enabled}
                  className="pt-1"
                  label={distributionChannelResponse.description}
                  name={setting.name}
                  type="checkbox"
                  onChange={handleChangeDistributionChannel}
                />
              </div>
            </Form>
          </div>
        );
      })}
    </>
  );
}
